import Cookies from 'js-cookie';
import { store } from '../app/store';
import HandleApprovalRequest from './Functions/ApprovalRequest';
const BASE_URL = process.env.REACT_APP_API_URL;

function socketAction(payload) {
  return {
    type: 'socket/toggleSocketStatus',
    payload
  };
}

function notificationAction(payload) {
  return {
    type: 'socket/addNotification',
    payload
  };
}

function poFeedbackAction(payload) {
  return {
    type: 'order/handleFeedbackApprovalRejection',
    payload
  };
}

function logoutAction() {
  return {
    type: 'auth/logout'
  };
}

class WSWrapper {
  constructor(url) {
    this.serverUrl = url;
  }

  connect() {
    store.dispatch(socketAction(false));
    this.ws = new WebSocket(this.serverUrl);
    this.ws.onopen = this.handleOpen;
    this.ws.onError = this.handleError;
    this.ws.onmessage = this.handleMessage;
    this.ws.onclose = this.handleClose;
  }

  close() {
    this.ws.close();
    store.dispatch(socketAction(false));
  }

  handleOpen(event) {
    store.dispatch(socketAction(true));
  }

  handleError(err) {
    console.log(
      '%c Socket connection error',
      'color:white;font-size:0.8rem;font-weight:bold;background-color: red; padding: 1px 4px;border-radius: 5px;'
    );
    console.log('Socket Error => ', err);
  }

  handleMessage = (event) => {
    const pathName = window.location.pathname;
    const message = JSON.parse(event.data);

    if (message.type === 'welcome') {
      console.log(
        '%c Socket connected successfully',
        'color:white;font-size:0.8rem;font-weight:bold;background-color: green; padding: 1px 4px;border-radius: 5px;'
      );
    } else if (message.type === 'approval-request') {
      const id = `${message.payload.poLine.documentNo}-${message.payload.poLine.lineNo}`;
      const companyBadge =
        message.payload.poLine.companyId === process.env.REACT_APP_COMP_EMM ? 'EMM' : 'DUN';
      const targetUrl = `/feedback-orders?range=none&skipPaginate=false&pageSize=20&currentPage=1&vendorNo=${message.payload.poLine.vendorNo}&VendorType=warehouse&companyBadge=${companyBadge}`;
      HandleApprovalRequest(message.payload, targetUrl);
      store.dispatch(
        notificationAction({
          message: {
            ...message.payload.poLine,
            amount: message.payload.amount,
            exceedancePercentage: message.payload.exceedancePercentage,
            exceedanceQuantity: message.payload.exceedanceQuantity,
            level: message.payload.level,
            seen: false,
            timeStamp: Date.now()
          },
          targetUrl,
          id
        })
      );
    } else if (message.type === 'poline-approved') {
      store.dispatch(
        poFeedbackAction({
          documentNo: message.payload.documentNo,
          lineNo: message.payload.lineNo,
          feedbackStatus: 'Approved',
          pathName
        })
      );
    } else if (message.type === 'poline-rejected') {
      store.dispatch(
        poFeedbackAction({
          documentNo: message.payload.documentNo,
          lineNo: message.payload.lineNo,
          feedbackStatus: 'Rejected',
          pathName
        })
      );
    }
  };

  handleClose = (event) => {
    const { auth } = store.getState();
    store.dispatch(socketAction(false));
    if (auth.isAuthenticated) {
      if (Cookies.get('expires_in')) {
        this.connect();
      } else {
        store.dispatch(logoutAction());
      }
    }
  };
}

export const initSocket = async () => {
  if (process.env.REACT_APP_USE_MOCKS === 'true') {
    return {
      connect: () => store.dispatch(socketAction(true)),
      close: () => store.dispatch(socketAction(false))
    };
  }
  const { auth } = store.getState();
  const wsURL = BASE_URL.replace(/^http/, 'ws') + '/ws?jwt=' + encodeURIComponent(auth.id_token);
  return new WSWrapper(wsURL);
};
